/*
 * Copyright (c) 2019 Signum+ Software & Facility GmbH
 * Author: jahn@signum-plus.at
 */

export function isNumber(value: any): boolean {
  if (typeof value === 'number') {
    return !Number.isNaN(value);
  }
  if (!value || typeof value !== 'string') {
    return false;
  }
  return /^[+\-]?(?:\d*(?:\.\d+)|\d+)(?:[Ee][+\-]\d+)?$/i.test(value);
}
